import React, { useEffect } from 'react';
import { Button, Select } from 'antd';
import { AETNA_FOCUS_AREAS, AETNA_FOCUS_DEFAULT, AETNA_FOCUS_MAX } from '../constants';
import { aetnaComplete } from '../validators';
import s from '../common.module.less';

interface Props {
    value: string[];
    onChange: (areas: string[]) => void;
    onContinue: () => void;
    // 编辑场景（review/Settings）按钮文案用 Save，默认 Continue
    continueLabel?: string;
    // group 宿主（ProviderPayerModal）传 true：零侧边对齐标题、footer 分隔线通边
    flush?: boolean;
    // review 行内编辑：只渲染表单 body，动作按钮由宿主（ReviewSection 吸底条）提供
    hideFooter?: boolean;
    onBack?: () => void;
    saving?: boolean;
}

// Aetna Practice focus areas：固定列表选最多 8 项；tag + 可搜索下拉（原型同款交互，用 antd
// multiple Select 实现）。首次进入按产品要求预选默认 8 项。
const AetnaFocusStep = ({
    value,
    onChange,
    onContinue,
    onBack,
    saving,
    continueLabel = 'Continue',
    flush,
    hideFooter,
}: Props) => {
    useEffect(() => {
        if (!value.length) onChange(AETNA_FOCUS_DEFAULT.slice());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const complete = aetnaComplete(value);

    return (
        <>
            <div className={`${s.modalBody} ${flush ? s.flushBody : ''}`}>
                <div className={s.focusCounter}>
                    {value.length} of {AETNA_FOCUS_MAX} selected
                </div>
                <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Select focus areas..."
                    value={value}
                    onChange={(v) => {
                        if (v.length <= AETNA_FOCUS_MAX) onChange(v);
                    }}
                    options={AETNA_FOCUS_AREAS.map((area) => ({
                        label: area,
                        value: area,
                        disabled: value.length >= AETNA_FOCUS_MAX && !value.includes(area),
                    }))}
                    showSearch
                    optionFilterProp="label"
                />
            </div>
            {!hideFooter && (
                <div className={`${s.modalFooter} ${flush ? s.flushFooter : ''}`}>
                    <Button
                        type="primary"
                        block
                        size="large"
                        className={s.primaryBtn}
                        disabled={!complete}
                        loading={saving}
                        onClick={onContinue}
                    >
                        {continueLabel}
                    </Button>
                    {onBack && (
                        <Button block size="large" className={s.backBtn} onClick={onBack}>
                            Back
                        </Button>
                    )}
                </div>
            )}
        </>
    );
};

export default AetnaFocusStep;
